var _rect, _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "currentColor",
    rx: 4,
    ry: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.553 11.904a2.56 2.56 0 0 0 .31-1.235q0-.729-.333-1.305-.323-.576-.98-.906-.655-.33-1.59-.33H4v8.21h1.613v-3.152H6.96q.99 0 1.636-.353.656-.352.956-.93Zm-1.67-.353q-.324.306-.991.306h-1.28V9.47h1.28q1.313 0 1.313 1.2 0 .563-.323.881Zm2.25 1.506q0-.988.38-1.753.392-.764 1.05-1.176.668-.411 1.485-.411.714 0 1.244.294.542.294.864.74v-.928h1.625v6.515h-1.625v-.953q-.31.459-.864.764-.541.295-1.255.294a2.7 2.7 0 0 1-1.475-.423 3 3 0 0 1-1.048-1.188q-.38-.776-.38-1.775Zm5.023.023q0-.6-.23-1.023a1.6 1.6 0 0 0-.622-.659 1.6 1.6 0 0 0-.841-.235q-.45 0-.83.224-.38.223-.622.658-.23.423-.23 1.012c0 .589.077.737.23 1.034q.242.435.623.67.39.237.829.236.45 0 .84-.223.393-.236.623-.659.23-.435.23-1.035M24 9.822l-3.951 9.596h-1.717l1.382-3.245-2.557-6.35h1.809l1.647 4.55 1.67-4.55z",
    clipRule: "evenodd"
  })));
});
const SvgPayAmFilled = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPayAmFilled);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI4IDI4Ij48cmVjdCB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9ImN1cnJlbnRDb2xvciIgcng9IjQiIHJ5PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOS41NTMgMTEuOTA0YTIuNTYgMi41NiAwIDAgMCAuMzEtMS4yMzVjMC0uNDg2LS4xMS0uOTIxLS4zMzMtMS4zMDUtLjIxNS0uMzg0LS41NDItLjY4Ni0uOTgtLjkwNi0uNDM3LS4yMi0uOTY3LS4zMy0xLjU5LS4zM0g0djguMjFoMS42MTN2LTMuMTUySDYuOTZjLjY2IDAgMS4yMDUtLjExOCAxLjYzNi0uMzUzLjQzNy0uMjM1Ljc1Ni0uNTQ1Ljk1Ni0uOTNabS0xLjY3LS4zNTNjLS4yMTYuMjA0LS41NDYuMzA2LS45OTEuMzA2aC0xLjI4VjkuNDdoMS4yOGMuODc1IDAgMS4zMTMuNCAxLjMxMyAxLjIgMCAuMzc1LS4xMDguNjctLjMyMy44ODFabTIuMjUgMS41MDZjMC0uNjU5LjEyNy0xLjI0My4zOC0xLjc1My4yNjItLjUxLjYxMS0uOTAxIDEuMDUtMS4xNzYuNDQ1LS4yNzQuOTQtLjQxMSAxLjQ4NS0uNDExLjQ3NiAwIC44OTEuMDk4IDEuMjQ0LjI5NC4zNjEuMTk2LjY1LjQ0My44NjQuNzR2LS45MjhoMS42MjV2Ni41MTVoLTEuNjI1di0uOTUzYy0uMjA3LjMwNi0uNDk1LjU2LS44NjQuNzY0LS4zNi4xOTctLjc4LjI5NC0xLjI1NS4yOTRhMi43IDIuNyAwIDAgMS0xLjQ3NS0uNDIzIDMuMDA5IDMuMDA5IDAgMCAxLTEuMDQ4LTEuMTg4Yy0uMjU0LS41MTctLjM4LTEuMTA5LS4zOC0xLjc3NVptNS4wMjMuMDIzYzAtLjQtLjA3Ni0uNzQtLjIzLTEuMDIzYTEuNTk0IDEuNTk0IDAgMCAwLS42MjItLjY1OSAxLjYwNSAxLjYwNSAwIDAgMC0uODQxLS4yMzVjLS4zIDAtLjU3Ni4wNzUtLjgzLjIyNC0uMjUzLjE0OS0uNDYuMzY4LS42MjIuNjU4LS4xNTMuMjgyLS4yMy42Mi0uMjMgMS4wMTJzLjA3Ny43MzcuMjMgMS4wMzRjLjE2Mi4yOS4zNjkuNTE0LjYyMy42Ny4yNi4xNTguNTM3LjIzNi44MjkuMjM2LjMgMCAuNTgtLjA3NS44NC0uMjIzLjI2Mi0uMTU3LjQ3LS4zNzcuNjIzLS42NTkuMTU0LS4yOS4yMy0uNjM1LjIzLTEuMDM1Wk0yNCA5LjgyMmwtMy45NTEgOS41OTZoLTEuNzE3bDEuMzgyLTMuMjQ1LTIuNTU3LTYuMzVoMS44MDlsMS42NDcgNC41NSAxLjY3LTQuNTVIMjRaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4K";